import { getImageUrl } from '@/common/utils/getImageUrl';
import getConfig from 'next/config';

export const buildDoctorAvatarUrl = (avatarPath?: string, doctorUserId?: string) => {
  const { publicRuntimeConfig } = getConfig();
  if (doctorUserId) return `https://pic.paziresh24.com/api/image/${doctorUserId}`;

  if (!avatarPath) return '';
  const absolutePicUrl = avatarPath.match(/https?:\/\/pic\.paziresh24\.com\/api\/image\/[^/?#]+/)?.[0];
  if (absolutePicUrl) return absolutePicUrl;

  // Last resort: preserve previous behavior when no identifier exists.
  return getImageUrl(avatarPath, publicRuntimeConfig.CDN_BASE_URL);
};

// Tried in order on load error: the pic photo, then the image the API returned (a pic 404 used to leave a broken image), then initials.
export const buildDoctorAvatarSources = (avatarPath?: string, doctorUserId?: string) => {
  const { publicRuntimeConfig } = getConfig();
  const sources = [buildDoctorAvatarUrl(avatarPath, doctorUserId)];
  if (avatarPath) sources.push(getImageUrl(avatarPath.trim(), publicRuntimeConfig.CDN_BASE_URL));
  // An image with no file name (/getImage/p24/search-men/) never loads.
  return Array.from(new Set(sources.filter(src => src && !src.endsWith('/'))));
};
